<template>
    <div>
        <div class="app-title">
            <div>
                <h2>{{ $t("tlt.threadHistory") }}</h2>
                <ul class="app-breadcrumb breadcrumb">
                    <li class="breadcrumb-item"><router-link to="/"><i class="fa fa-home"></i></router-link></li>
                    <li class="breadcrumb-item"><router-link to="/adm"><span>{{$t('tlt.administration')}}</span></router-link></li>
                    <li class="breadcrumb-item"><router-link to="/adm/threadHistory"><span>{{$t('tlt.threadHistory')}}</span></router-link></li>
                </ul>
            </div>
        </div>
        <section class="app-content">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div
                        id="collapseOne"
                        class="collapse show "
                        aria-labelledby="headingOne"
                        data-parent="#accordionFilter"
                        >
                        <div class="card-body">
                            <form>
                                <div class="row">                                    
                                    <div class="form-group col-md-2">
                                        <label class="control-label">
                                            {{ $t("lbl.basic.process") }}:
                                        </label>
                                        <select class="form-control" v-model="processFilter">
                                            <option value="">{{ $t("lbl.basic.select.one") }}</option>
                                            <option v-for="pd in processDefinition" 
                                            :value="pd.id" :key=pd.id>{{pd.name}}</option>
                                        </select>
                                    </div>
                                    <div class="form-group col-md-2">
                                        <label class="control-label">{{$t('lbl.basic.from')}}:</label>
                                        <mmf-datetimepicker name="fromFilter"
                                                        :date="defaultDateFrom"
                                                        v-model="fromFilter"></mmf-datetimepicker>
                                    </div>
                                    <div class="form-group col-md-2">
                                        <label class="control-label">{{$t('lbl.basic.to')}}:</label>
                                        <mmf-datetimepicker name="toFilter"
                                                        :date="defaultDateTo"
                                                        v-model="toFilter"></mmf-datetimepicker>
                                    </div>
                                    <div class="form-group col-md-2">
                                        <label class="control-label">{{ $t("lbl.basic.status") }}:</label>
                                        <select class="form-control" v-model="statusFilter">
                                            <option value="">{{ $t("lbl.basic.select.one") }}</option>
                                            <option value="P">{{ $t("lbl.threadHistory.status.processing") }}</option>
                                            <option value="S">{{ $t("lbl.threadHistory.status.success") }}</option>
                                            <option value="E">{{ $t("lbl.threadHistory.status.error") }}</option>
                                            <option value="C">{{ $t("lbl.threadHistory.status.canceled") }}</option>
                                        </select>
                                    </div>
                                    <div class="form-group col-md-2">
                                    </div>
                                </div>
                                <div class="row">  
                                    <div class="form-group col-md-2">
                                        <label class="control-label">
                                            {{ $t("lbl.threadHistory.threadGroup") }} :
                                        </label>
                                        <input class="form-control" type="text" v-model="threadGroupFilter"/>
                                    </div>
                                    <div class="form-group col-md-2">
                                        <label class="control-label">
                                            {{ $t("lbl.threadHistory.threadSummary") }}:
                                        </label>
                                        <input class="form-control" type="text" v-model="threadSummaryFilter"/>
                                    </div>
                                    <div class="form-group col-md-2">
                                        <label class="control-label">
                                            {{ $t("lbl.threadHistory.threadId") }}:
                                        </label>
                                        <input class="form-control" type="text" v-model="threadIdFilter"/>
                                    </div>
                                    <div class="form-group col-md-2">
                                    </div>
                                    <div class="form-group col-md-2">
                                    </div>
                                    <div class="col-lg-2 align-self-end">
                                        <div class="float-lg-right">
                                            <button class="btn btn-outline-secondary mr-1" type="button" 
                                            v-on:click="MMFClearFilter('threadHistory')">
                                                <i class="fa fa-fw fa-lg fa-eraser"></i>
                                                <span class="text">{{ $t("btn.basic.clear") }}</span>
                                            </button>
                                            <button class="btn btn-primary" type="button" v-on:click="MMFLoadRows('threadHistory')">
                                                <i class="fa fa-fw fa-lg fa-search"></i>
                                                <span class="text">{{ $t("btn.basic.search") }}</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            <div id="threadHistoryResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo"
                         class="collapse show"
                         aria-labelledby="headingTwo"
                         data-parent="#accordionResult">

                        <div class="card-body">
                            <mmf-table entity="threadHistory" inline-actions-disabled checkbox-column-disabled>
                            </mmf-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { createHelpers } from 'vuex-map-fields';
import {gridFields, filterFields}  from "@/model/adm/ThreadHistory";
import MmfTable from "@/components/MmfTable";
import MmfDatetimepicker from "@/components/MmfDatetimepicker";
import * as moment from 'moment';

// create a helper to generate getters and setters with namespace
const { mapFields } = createHelpers({
    getterType: 'threadHistory/getField',
    mutationType: 'threadHistory/updateField',
  });

export default {
  data () {
    return {
      defaultDateFrom: moment().add(-3, 'days'),
      defaultDateTo: new moment(),
      currentPage: 1,
      perPage: 15
    }
  },
  components: { 
      MmfTable,
      MmfDatetimepicker
  },
  name: "threadHistoryList",
  computed: {
        // generate and add getters and setters using the filter names defined in
        // entity model
        ...mapFields(filterFields),
        //define the state of rows and fields of grid
        ...mapState({
            rows: state => state.threadHistory.rows,
            showNoResultAlert: state => state.base.showNoResultAlert,
            tableColumns: gridFields,
            processDefinition: state => state.threadHistory.processDefinition
        })
  },
  methods: {
    ...mapActions("base", ["MMFLoadRows", "MMFClearFilter"])
  },
  mounted(){
      this.$store.dispatch('threadHistory/loadProcessDefinition');
  }
};
</script>
